import SearchSelectionInput, {
  SearchSelectionInputProps,
  OptionSearchSelectionProps,
} from './SearchSelectionInput';

export type { SearchSelectionInputProps, OptionSearchSelectionProps };
export default SearchSelectionInput;
